import React from 'react';
import { Box } from '@mui/system';
import { Skeleton } from '@mui/material';

const PostCommentsSkeleton = () => {
    return (
        <Box>
            <Box sx={{ ml: '-4px', mt: 1, display: 'flex', flexDirection: 'column', rowGap: 3 }}>
                {Array.from({ length: 5 }).map((val, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'start' }}>
                        <Skeleton sx={{ width: 24, height: 24, mt: 1 }} variant="circular" />
                        <Box>
                            <Skeleton sx={{ width: 312, height: 64, ml: 0.5 }} />
                            <Skeleton sx={{ width: 122, height: 24, ml: 0.5, mt: 1 }} />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PostCommentsSkeleton;
